module.exports = __webpack_public_path__ + "media/images/emblems/Seedorf_BE-coat_of_arms-63cd98b2525b5daef298e5e05cafa01f.svg";